<div class="elementsBar row">
  <div class="elementsBarBtns col-6">
    @if (canCreate && permissions?.insert) {
    <button mat-button (click)="showCreatePopup()" class="CreatButton">
      <svg class="pc-icon">
        <use xlink:href="assets/fonts/custom-icon.svg#addItem"></use>
      </svg>
      {{ 'create' | translate }}
    </button>
    }
    <button mat-button (click)="showFilterPopup()" class="FilterButton">
      <svg class="pc-icon">
        <use xlink:href="assets/fonts/custom-icon.svg#filterSearch"></use>
      </svg>
      {{ 'filter' | translate }}
    </button>

    <button mat-button (click)="favouriteClick()" [style.color]="favColor" class="FavoriteButton">
      <svg class="pc-icon">
        <use xlink:href="assets/fonts/custom-icon.svg#star-colored"></use>
      </svg>
      {{ 'addtoFavorite' | translate }}
    </button>

    @if (showRestoreBtn) {
    <button mat-button (click)="restore()" class="RestoreButton">
      <svg class="pc-icon">
        <use xlink:href="assets/fonts/custom-icon.svg#reload"></use>
      </svg>
      {{ 'restore' | translate }}
    </button>
    }
  </div>

  <div class="searchExport col-6 ">
    <div class="view-more-group">
      @if (availableViews.length > 1) {
      <div class="view-toggle-container">
        @for (viewConfig of availableViews; track viewConfig.mode) {
        <button
          mat-icon-button
          class="view-toggle-btn"
          [class.active]="currentView === viewConfig.mode"
          (click)="onViewModeClick(viewConfig.mode)"
          [matTooltip]="viewConfig.labelKey | translate"
          matTooltipPosition="below">
          <mat-icon>{{ viewConfig.icon }}</mat-icon>
        </button>
        }
      </div>
      }

      @if (availableViews.length > 1 && (permissions?.print || permissions?.export)) {
      <span class="toolbar-divider" aria-hidden="true"></span>
      }

      <!-- p-t-20 -->
      <!-- <mat-form-field appearance="outline">
        <input matInput (keyup)="applySearch($event)" placeholder="{{ 'search' | translate }}" />
        <mat-icon matSuffix class="search-icons">
          <svg class="pc-icon">
            <use xlink:href="assets/fonts/custom-icon.svg#custom-search"></use>
          </svg>
        </mat-icon>
      </mat-form-field> -->

      @if (permissions?.print || permissions?.export) {
      <mat-form-field
        appearance="outline"
        class="more-select"
        [ngClass]="{
          'mat-form-field-compact':size === 'compact',
          'mat-form-field-xs': size === 'xs',
        }">
        <mat-label>{{ 'more' | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedOption" name="exOption">
          @for (exOption of exportOptions; track exOption) {
          <mat-option [value]="exOption.value" (click)="onOptionClicked(exOption.value)">{{ exOption.viewValue |
            translate }}</mat-option>
          }

          @for (item of extraDynamicMenu; track item) {
          <mat-option [value]="'Command_' + item.functionName"
            (click)="onOptionClicked('Command_' + item.functionName)">{{
            item.commandName | translate
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      }
    </div>
  </div>
</div>
